import { axios } from "../../helper/axios";
import { ConfigurationConstant } from "./ConfigurationConstant";

const ConfigurationApi = {};

ConfigurationApi.getConfigurationTableApi = () => {
  return axios.get(ConfigurationConstant.CONFIGURATION_TABLE_API);
};

ConfigurationApi.UpdateConfigurationCancelApi = (payload) => {
  return axios.put(ConfigurationConstant.CONFIGURATION_UPDATE_CANCEL_API, {
    id: payload.id,
    convenience: payload.convenience,
    referal_amount: payload.referal_amount,
    loyality_point: payload.loyality_point,
    gift_voucher_amount: payload.gift_voucher_amount,
  });
};

export { ConfigurationApi };
